import { getSiteUrl, SITE_NAME } from '../config/site';

export function buildWebsiteJsonLd() {
  const siteUrl = getSiteUrl();
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: SITE_NAME,
    url: siteUrl,
    logo: `${siteUrl}/logo.png`,
    inLanguage: 'pl-PL',
  };
}
